import * as types from '../actions/actionTypes.js';
import initialState from "./initialState.js";

export function resourceReducer(
  state = initialState.resources, action
  ) {
  switch(action.type) {
    case types.FETCH_FIND_RESOURCE_SUCCESS:
      return action.resources;
    default:
      return state;
  }
}


export function selectedResourceReducer(
  state = initialState.selectedResource, action
  ) {
  switch(action.type) {
    case types.UPDATE_SELECTED_RESOURCE:
      return action.selectedResource;
    default:
      return state;
  }
}

export function selectedDayTypeResourceReducer(
  state = initialState.selectedDayTypeResource, action
  ) {
  switch(action.type) {
    case types.UPDATE_SELECTED_DAY_TYPE_RESOURCE:
      return action.selectedDayTypeResource;
    default:
      return state;
  }
}

export function resourcePersonnelDataReducer(
  state = initialState.resourcePersonnelData, action
  ) {
  switch(action.type) {
    case types.FETCH_RESOURCE_PERSONNEL_DATA_SUCCESS:
      return action.resourcePersonnelData;
    default:
      return state;
  }
}

export function resourceContactInfoReducer(
  state = initialState.resourceContactInfo, action
  ) {
  switch(action.type) {
    case types.FETCH_RESOURCE_CONTACT_INFO:
      return action.resourceContactInfo;
    default:
      return state;
  }
}
